import React from "react";
import "./App.css";
import CarGallery from "./Components/Cars/CarGallery";
import HeroSection from "./Components/HeroSection";

const App = () => {
  return (
    <div className="App">
      <HeroSection />
      <CarGallery />
    </div>
  );
};

export default App;
